import type { ReferencePatent } from '../types';

/**
 * 获取参考专利信息的 Service
 */
export interface ReferencePatents {
    /**
     * 拉取参考专利信息
     * @param patentNo
     * @returns 参考专利信息
     */
    pullReferencePatent: (patentNo: string) => Promise<ReferencePatent>;
}

export const ReferencePatents = Symbol('ReferencePatents');
